import { getUserInfoActionComposable, instanceComposable } from '@/composables';
import { CHANNEL_ID_KEY } from '@/constants';
import { showToast } from 'vant';

export default [
  (to, from, next) => {
    const channelId = to.query[CHANNEL_ID_KEY];
    if (channelId) {
      localStorage.setItem(CHANNEL_ID_KEY, JSON.stringify(decodeURIComponent(channelId)));
    }
    next();
  },
  (to, from, next) => {
    console.log(to);
    const { token } = to.query;
    try {
      if (token && !/null/.test(token)) {
        // 去除授权参数
        const toQuery = { ...to.query };
        delete toQuery.token;
        localStorage.setItem('token', JSON.stringify(decodeURIComponent(token || '')));
        next({ name: to.name, params: to.params, path: to.path, query: toQuery, replace: true });
      } else {
        next();
      }
    } catch (error) {
      console.error(error);
      // alert(error);
    }
  },
  async (to, from, next) => {
    // // 获取与设置国家地区
    // const resConfig = await getLoginAreaConfigActionComposable;
    // console.log(resConfig);
    if (to.meta.auth !== 1) {
      next();
      return;
    }
    // 页面访问控制
    const userInfo = await getUserInfoActionComposable;
    console.log('userInfo:', userInfo);
    if (!userInfo.userId) {
      showToast(instanceComposable.getI18n().global.t('cfmoto.api.http.401'));
      return;
    } else {
      next();
    }
  },
  async (to, from, next) => {
    // 待待jssdk注入
    await window.cfmoto.awaitInject();
    next();
  },
];
